export default __webpack_public_path__ + "static/media/G0350.34I-26158_-17369_0.1666262220000.7b0f909b.jpg";